import { Injectable } from '@angular/core';
import {
    IAssetTitles,
    IAssetType,
} from '../../../pages/private/dashboard/assets/assets-main/assets-main-manager.service';
import { IUpdateTakeImage } from 'src/app/services/http-models/project/take/take-http-request-model';
import { UnsplashManagerService } from '../../shared/major/photos-collection/unsplash-collection/unsplash-manager.service';
import { WorkspaceAssetActionService } from '../../../services/workspace/actions/workspace-asset-action.service';
import { AssetsLibraryServiceService } from '../../../pages/private/dashboard/assets/asset-library/assets-library-service.service';
import { AssetUtilsService } from '../../../services/shared/utils/asset-utils.service';
import { WorkspaceAssetStateManagerService } from '../../../services/workspace/state-management/associations/workspace-asset-state-manager.service';
import { BehaviorSubject, combineLatest, filter } from 'rxjs';
import { ConfigurationService } from '../../../services/configuration.service';
import { ILocalAsset } from '../../../models/assets/assets.model';
import { ProfileService } from '../../../services/show/profile.service';
import { FeatureService } from '../../../services/feature-service.service';

@Injectable()
export class GenerateNewAssetFunctionalService extends AssetsLibraryServiceService {
    override displayTitles: IAssetTitles = {
        generate: false,
        library: false,
        videoLibrary: false,
        upload: false,
        generateVideo: false,
    };
    override toDisplayLoading = false;
    override toMakeUploadAsMainButton = false;
    override toDisplayHeader = false;
    override asset: IAssetType = 'image';
    override toDisplaySelectAsset = true;
    private _currentAssetIdSubject = new BehaviorSubject<string>(null);
    public currentAssetId$ = this._currentAssetIdSubject.asObservable();

    private _currentImageAssetUrl = new BehaviorSubject<string>(null);
    public currentImageAssetUrl$ = this._currentImageAssetUrl.asObservable();

    private _currentAssetSubject = new BehaviorSubject<ILocalAsset>(null);
    public currentAsset$ = this._currentAssetSubject.asObservable();

    private _generatedAssetIdSubject = new BehaviorSubject<string>(null);
    public generatedAssetId$ = this._generatedAssetIdSubject.asObservable();

    private _generatedAssetUrlSubject = new BehaviorSubject<string>(null);
    public generatedAssetUrl$ = this._generatedAssetUrlSubject.asObservable();

    private _generatedAssetSubject = new BehaviorSubject<ILocalAsset>(null);
    public generatedAsset$ = this._generatedAssetSubject.asObservable();
    constructor(
        unsplashService: UnsplashManagerService,
        assetUtilsService: AssetUtilsService,
        wsAssetActionService: WorkspaceAssetActionService,
        wsAssetState: WorkspaceAssetStateManagerService,
        private configurationService: ConfigurationService,
        unleashService: FeatureService
    ) {
        super(unsplashService, assetUtilsService, wsAssetActionService, wsAssetState, unleashService);
        combineLatest([wsAssetState.assets$, this._currentAssetIdSubject])
            .pipe(filter(([assets, currentAssetId]) => !!assets && !!currentAssetId))
            .subscribe(([assets, currentAssetId]) => {
                const currentAsset = assets.find((asset) => asset._id === currentAssetId);
                if (!currentAsset) {
                    return;
                }

                this.setCurrentImageUrl(this.configurationService.baseCdnUrl + currentAsset.uploadPath);
                this._currentAssetSubject.next(currentAsset);
            });
        combineLatest([wsAssetState.assets$, this._generatedAssetIdSubject])
            .pipe(filter(([assets, generatedAssetId]) => !!assets && !!generatedAssetId))
            .subscribe(async ([assets, generatedAssetId]) => {
                ////// Get asset
                const generatedAssets = await wsAssetActionService.getAssetsByIdsAsync(generatedAssetId);
                if (!generatedAssets) {
                    return;
                }
                const generatedAsset = generatedAssets[0];
                this.setCurrentImageUrl(this.configurationService.baseCdnUrl + generatedAsset.uploadPath);
                this.setGenerateAssetObject(generatedAsset);
            });
    }

    setToEnableModes(toEnableImageToVideo: boolean, toEnableGenerateImage: boolean) {
        this.toEnableEditImage = toEnableGenerateImage;
        this.toEnableImageToVideo = toEnableImageToVideo;
    }
    setGenerateAssetObject(generatedAsset: ILocalAsset | null) {
        this._generatedAssetSubject.next(generatedAsset);
    }
    override async createNewAssetAsync(updateImage: IUpdateTakeImage) {
        if (!updateImage?.pickAsset?.imageId) {
            throw new Error(`Could not generate video from image because pick image is not valid.`);
        }
        const { imageId } = updateImage.pickAsset;
        this.setCurrentAsset(imageId);
        return true;
    }

    setCurrentAsset(assetId: string) {
        this.setCurrentImageUrl(null);
        this._currentAssetIdSubject.next(assetId);
    }
    setCurrentImageUrl(imageUrl: string | null) {
        this._currentImageAssetUrl.next(imageUrl);
    }
    setGeneratedAssetId(assetId: string) {
        this._generatedAssetIdSubject.next(assetId);
    }
}
